export default __webpack_public_path__ + "static/media/1355.706596e0.png";